class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.productWrapper = this.closest('.product-item-js')

    this.addEventListener('change', this.onVariantChange);
    if (!this.querySelector('.color-swatch-list')) return;
    this.variantRadios = this.querySelectorAll('.color-swatch-list');
    this.variantRadiosInputs = this.querySelectorAll('.color-swatch-list input');
    // this.variantRadiosInputs.forEach(input => input.addEventListener('change', this.onVariantChange.bind(this) ));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.renderProductInfo();
    this.updateOptionsLabels();
    // this.removeErrorMessage();

    if (!this.currentVariant) {
      this.updateAvailability(false);
    } else {
      this.updateAvailability(this.currentVariant.available);
      this.updateMedia();
      // console.log(this.currentVariant);
      // this.updateURL();
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('.variant-selector select'), (select) => select.value);
    if (!this.variantRadios.length > 0) return;
    const swatches = Array.from(this.variantRadios);
    this.options = this.options.concat(
      swatches.map((swatch) => {
        return Array.from(swatch.querySelectorAll('input')).find((radio) => radio.checked).value;
      })
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const originalImageElement = this.productWrapper.querySelector('.aspect-ratio img');
    let featured_media_Src = this.currentVariant.featured_media.preview_image.src;
    featured_media_Src = featured_media_Src.substring(0, featured_media_Src.lastIndexOf('.')) + '`' + featured_media_Src.substring(featured_media_Src.lastIndexOf('.') + 1);
    featured_media_Src = featured_media_Src.replace('`', '_{width}x.');
    // console.log(featured_media_Src);
    var newImageElement = document.createElement('img');
    newImageElement.className = 'lazyload image--fade-in';
    newImageElement.setAttribute('data-src', featured_media_Src);
    newImageElement.setAttribute('data-widths', originalImageElement.getAttribute('data-widths'));
    newImageElement.setAttribute('data-sizes', 'auto');

    originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);

  }

  updateVariantInput() {
    const input = this.productWrapper.querySelector('input[name="quantity"]');
    input.dataset.variantId = this.currentVariant.id;

    this.productWrapper.querySelector('[name="id"]').value = this.currentVariant.id;

    this.productWrapper.querySelector('[name="quantity"]').dataset.price = this.currentVariant.price;

    this.productWrapper.querySelector('[name="quantity"]').dataset.variantTitle = this.currentVariant.title;

    //input.setAttribute('max', window.builderVariantsStocks[this.currentVariant.id.toString()]);
    //if (parseInt(input.value) > parseInt(input.max)) input.value = input.max;
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=price&section_id=builder-item-price`)
      .then((response) => response.text())
      .then((responseText) => {

        let html = new DOMParser().parseFromString(responseText, 'text/html')
        let destination = this.productWrapper.querySelector('.product-item__price-list');
        let source = html.querySelector('.product-item__price-list');

        if (source && destination) destination.innerHTML = source.innerHTML;

      });
  }

  updateOptionsLabels() {
    this.querySelectorAll('.product-form__selected-value').forEach((label, index) => {
      const option = "option".concat(++index);
      label.innerHTML = this.currentVariant[option];
    })
  }

  updateAvailability(available) {
    if (available) {
      this.productWrapper.querySelector('.quantity-selector').classList.remove('tw-hidden');
      this.productWrapper.querySelector('.sold-out-label-js').classList.add('tw-hidden');
    } else {
      this.productWrapper.querySelector('.quantity-selector').classList.add('tw-hidden');
      this.productWrapper.querySelector('.sold-out-label-js').classList.remove('tw-hidden');
    }
  }

  getVariantData() {
    if (this.querySelector('[type="application/json"]')) {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    } else {
      this.variantData = this.variantData || JSON.parse(this.parentElement.querySelector('variant-selects').querySelector('[type="application/json"]').textContent);
    }
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

// Function to make the color filter selected if the general color swatch has been clicked
function cabinetCollectionGeneralColorSwatch() {
  var generalColorSwatches = document.querySelectorAll(".hp-general-color-swatch .color-swatch__radio");
  var filterColorSwatches = document.querySelectorAll('.collection__filter-color-list .color-swatch-list--large .color-swatch__radio')
  generalColorSwatches.forEach((genSwatch) => {
    genSwatch.addEventListener("change", () => {
      var selectedGenSwatch = genSwatch.value;
      
      filterColorSwatches.forEach((filSwatch) => {
        filSwatch.removeAttribute("checked");
        filSwatch.checked = false;
        if (filSwatch.value == selectedGenSwatch) {
          console.log('filSwatch', filSwatch);
          setTimeout(() => {
            console.log('filSwatch', filSwatch);
            filSwatch.setAttribute("checked", '');
            filSwatch.checked = true;
            filSwatch.dispatchEvent(new Event('change'));
            filSwatch.parentElement.dispatchEvent(new CustomEvent('filter:update', { bubbles: true }));
          }, 1);
        }
      });
      
      
    })
  })
}
cabinetCollectionGeneralColorSwatch();
document.addEventListener('collection:updated', cabinetCollectionGeneralColorSwatch);

// Function to make the color filter disappear in cabinets collection only
if(document.querySelector("#filter-v-option-colour")){
    function hideColorFilter(){
      var cabinetsColorFilter = document.querySelector("#filter-v-option-colour")
      cabinetsColorFilter.parentNode.style.display = "none"
    }
    hideColorFilter()
}